import styled from 'styled-components';

export const AccountSetupP = styled.p`
  text-align: center;
  margin-top: 20px;
`;
